import React, { memo, useEffect, useState } from 'react';
import { Navbar, Nav, NavItem } from 'reactstrap';

import FeedbackModal from './FeedbackModal';
import { toProperCase } from '../../services/library';
import ChangePasswordModal from './ChangePasswordModal';
import OpDecalsModal from './OpDecalsModal';
import WindowStickerBuyersguideOrderModal from './WindowStickerBuyersguideOrderModal';
import ContextMenuComponent from '../../components/GeneralForm/ContextMenuComponent';
import { svgProfileSetting } from '../../constants/svgConst';
import {
  EDITORPROFILE_PAGE_PATH,
  INTEGRATION_PAGE_PATH,
  LOGIN_PAGE_PATH,
  THEME_DOCS_PAGE_PATH
} from '../../constants/appPathConst';
import { hasActionPermission, hasModulePermission } from '../../generalUtils/rbacUtils';
import {
  MODULE_SOCIAL_MEDIA_INTEGRATION,
  MODULE_THEME_DOCS,
  MODULE_APP_GLOBAL,
  MODULE_MY_PROFILE
} from '../../constants/moduleSlugConst';
import ProfileAvatar from '../../components/GeneralForm/ProfileAvatar';
import CustomToggleSwitch from '../../components/GeneralForm/CustomToggleSwitch';
import { performThemeFn } from '../../generalUtils/themeStyleTag';
import { DARK_MODE, LIGHT_MODE } from '../../generalUtils/themeClasses';
import { saveThemeColors } from '../../services/themeService';
import {
  ACTION_ORDER_PROGRESS_DECALS,
  ACTION_SUBMIT_FEEDBACK,
  ACTION_WIN_STICKER_BUY_GUIDE_ORDER,
  ACTION_TOGGLE_SALES_DEMO_MODE,
  ACTION_SEND_INSTANT_PHOTO_REPORT,
  ACTION_SEND_INSTANT_IMPORT_REPORT
} from '../../constants/actionSlugConst';
import NeedTrainingComponent from './NeedTrainingComponent';
import ImportReportModal from './ImportReportModal';
import PhotoReportModal from './PhotoReportModal';

const NavbarComponent = props => {
  const [feedbackIsOpen, setFeedbackIsOpen] = useState(false);
  const {
    user,
    navigate,
    isSidebarVisible,
    handleAuthLogout,
    changePasswordToggle,
    handleChangePasswordToggle,
    opDecalsToggle,
    handleOpDecalsToggle,
    windowStickerBuyersguideOrderToggle,
    handleWindowStickerBuyersguideOrderToggle,
    handleLayoutIsDisplaySidebar,
    dealer,
    themeArr,
    handleUnSetUserNDealer,
    handleUnSetAuthToken,
    handleUpdateDemoMode,
    isDemoMode,
    handleNeedTrainingToggle,
    needTraining,
    is5PmReportModalOpen,
    isPhotoReportModalOpen,
    set5PmReportModalOpen,
    setPhotoReportModalOpen
  } = props;
  const { isLightTheme, baseThemeColorArr } = themeArr;

  const feedbackToggle = () => {
    setFeedbackIsOpen(!feedbackIsOpen);
  };

  const changePasswordToggleModalToggle = () => {
    handleChangePasswordToggle(!changePasswordToggle);
  };

  const opDecalsToggleModalToggle = () => {
    handleOpDecalsToggle(!opDecalsToggle);
  };

  const needTrainingModalToggle = () => {
    handleNeedTrainingToggle(!needTraining);
  };

  const owindowStickerBuyersguideOrderModalToggle = () => {
    handleWindowStickerBuyersguideOrderToggle(!windowStickerBuyersguideOrderToggle);
  };

  const handleSideBarTrigger = () => {
    handleLayoutIsDisplaySidebar(!isSidebarVisible);
  };

  const handleChangeDemoMode = e => {
    const { checked } = e.currentTarget;
    const confirmationMessage = `Do you want to ${checked ? 'enable' : 'disable'} demo sales mode?`;

    if (window.confirm(confirmationMessage)) {
      handleUpdateDemoMode(checked);
      window.location.reload();
    }
  };

  const sendInstatImportReportModalToggle = () => {
    set5PmReportModalOpen(!is5PmReportModalOpen);
  };

  const sendInstantPhotoReportModalToggle = () => {
    setPhotoReportModalOpen(!isPhotoReportModalOpen);
  };

  const menuOption = {
    buttonDropdown: { id: 'profileMenuOptionId' },
    dropdownToggle: {
      color: 'link',
      children: svgProfileSetting,
      toggleIcon: false
    },
    dropdownMenu: {
      className: 'p-2 r-20',
      width: '280px',
      options: [
        {
          className: 'p-3 d-block',
          notDropdownClass: true,
          children: (
            <div>
              <div className="text-center mb-2">
                <ProfileAvatar displayName={user?.user_initial} isActive={user?.user_isactive} />

                <div className="fs-18 fw-600 text-white">{user ? `Hi, ${user?.user_displayname} !` : ''}</div>
                {user &&
                  (user?.user_position ? (
                    <div title="Position" className="text-dark-100 fs-16">
                      {user ? toProperCase(user?.user_position) : ''}
                    </div>
                  ) : (
                    <div title="Logged in as" className="text-dark-100 fs-16">
                      {user ? toProperCase(user?.user_role_name) : ''}
                    </div>
                  ))}
              </div>
              <div className="text-white fs-16">{user ? user?.user_email : ''}</div>
            </div>
          )
        },
        {
          label: 'My Profile',
          className: 'bb-1 bt-1',
          isvisible: hasModulePermission([MODULE_MY_PROFILE]),
          onClick: () => {
            navigate(EDITORPROFILE_PAGE_PATH);
          }
        },
        {
          label: 'Social Media Integration',
          className: 'bb-1',
          isvisible: dealer?.integration && hasModulePermission([MODULE_SOCIAL_MEDIA_INTEGRATION]),
          onClick: () => {
            navigate(INTEGRATION_PAGE_PATH);
          }
        },
        {
          label: 'Theme Docs',
          className: 'bb-1',
          isvisible: hasModulePermission([MODULE_THEME_DOCS]),
          onClick: () => {
            window.open(THEME_DOCS_PAGE_PATH);
          }
        },
        {
          label: 'Change Password...',
          className: 'bb-1',
          isvisible: true,
          onClick: () => changePasswordToggleModalToggle()
        },
        {
          label: 'Order Progress Decals...',
          className: 'bb-1',
          isvisible:
            dealer?.dealerSticker && hasActionPermission([ACTION_ORDER_PROGRESS_DECALS], [MODULE_APP_GLOBAL]),
          onClick: () => opDecalsToggleModalToggle()
        },
        {
          label: "Order Window Stickers &/or Buyer's Guides...",
          className: 'bb-1',
          isvisible:
            dealer?.dealerSticker &&
            hasActionPermission([ACTION_WIN_STICKER_BUY_GUIDE_ORDER], [MODULE_APP_GLOBAL]),
          onClick: () => owindowStickerBuyersguideOrderModalToggle()
        },
        {
          label: `Contact Support`,
          // icon: `fa-external-link`,
          className: 'bb-1',
          isvisible: true,
          onClick: () => {
            window.open(
              'https://dealerimagepro.my.site.com/support/s/contactsupport?language=en_US',
              '_blank'
            );
          }
        },
        {
          label: 'Submit Feedback...',
          className: 'bb-1',
          onClick: () => feedbackToggle(),
          isvisible: hasActionPermission([ACTION_SUBMIT_FEEDBACK], [MODULE_APP_GLOBAL])
        },
        {
          label: 'Need Training...',
          className: 'bb-1',
          isvisible: true,
          onClick: () => needTrainingModalToggle()
        },
        {
          label: '5 PM Report...',
          className: 'bb-1',
          isvisible: hasActionPermission([ACTION_SEND_INSTANT_IMPORT_REPORT], [MODULE_APP_GLOBAL]),
          onClick: () => sendInstatImportReportModalToggle()
        },
        {
          label: 'Photo Report...',
          className: 'bb-1',
          isvisible: hasActionPermission([ACTION_SEND_INSTANT_PHOTO_REPORT], [MODULE_APP_GLOBAL]),
          onClick: () => sendInstantPhotoReportModalToggle()
        },
        {
          label: 'Logout',
          isvisible: !user?.isdirectlogin,
          onClick: () => {
            handleUnSetUserNDealer();
            handleUnSetAuthToken();
            handleAuthLogout();
            navigate(LOGIN_PAGE_PATH);
          }
        }
      ]
    }
  };

  const onThemeChange = async e => {
    const checked = e.currentTarget.checked;
    const response = await saveThemeColors({
      themeArr: baseThemeColorArr.filter(d => d.theme_isvisible),
      user_id: user?.user_id,
      mode: checked ? LIGHT_MODE : DARK_MODE,
      isLightTheme: checked
    });
    if (response.status) {
      await performThemeFn({ user_id: user?.user_id });
    }
  };

  useEffect(() => {
    const handleKeyDown = event => {
      if (event.ctrlKey && event.key === 'b') {
        event.preventDefault(); // prevent browser save
        handleLayoutIsDisplaySidebar(!isSidebarVisible);
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isSidebarVisible]);

  return (
    <>
      <Navbar dark color={isLightTheme ? 'gray-900' : 'dark-900'} expand="xs" className={`layout__navbar`}>
        <Nav navbar>
          <NavItem className="mr-xl-3 mr-lg-3" style={{ cursor: 'pointer' }} onClick={handleSideBarTrigger}>
            <span className="nav-link">
              <i className="fa fa-fw fa-bars text-primary-300 fs-18" />
            </span>
          </NavItem>
        </Nav>

        <ChangePasswordModal modalTrigger={changePasswordToggleModalToggle} {...props} />

        {dealer?.dealerSticker && hasActionPermission([ACTION_ORDER_PROGRESS_DECALS], [MODULE_APP_GLOBAL]) ? (
          <OpDecalsModal modalTrigger={opDecalsToggleModalToggle} {...props} />
        ) : null}

        {dealer?.dealerSticker &&
        hasActionPermission([ACTION_WIN_STICKER_BUY_GUIDE_ORDER], [MODULE_APP_GLOBAL]) ? (
          <WindowStickerBuyersguideOrderModal
            modalTrigger={owindowStickerBuyersguideOrderModalToggle}
            {...props}
          />
        ) : null}

        <FeedbackModal isOpen={feedbackIsOpen} toggle={feedbackToggle} {...props} />
        <NeedTrainingComponent isOpen={needTraining} toggle={needTrainingModalToggle} {...props} />
        <ImportReportModal
          isOpen={is5PmReportModalOpen}
          toggle={sendInstatImportReportModalToggle}
          {...props}
        />
        <PhotoReportModal
          isOpen={isPhotoReportModalOpen}
          toggle={sendInstantPhotoReportModalToggle}
          {...props}
        />

        <div
          style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}
        >
          <div id="portal-root-navbar" />
          <div className="d-flex align-items-center mt-1">
            <div className="b-1 d-flex" style={{ padding: '4px 10px' }}>
              {hasActionPermission([ACTION_TOGGLE_SALES_DEMO_MODE], [MODULE_APP_GLOBAL]) && (
                <CustomToggleSwitch
                  id="sales_demo_mode_toggle"
                  name="sales_demo_mode_toggle"
                  isChecked={isDemoMode}
                  onChange={handleChangeDemoMode}
                  // size="md"
                  className="mr-1"
                  title="Masks dealer-identifiable information for safe demos."
                  label="Demo mode"
                  labelPosition="left"
                />
              )}
              <CustomToggleSwitch
                id="theme_switch"
                isChecked={isLightTheme || false}
                onChange={onThemeChange}
                title={isLightTheme ? 'Switch to Dark Mode' : 'Switch to Light Mode'}
                // size="md"
                color="dark-400"
                className="mr-1"
                hasIcon={{ checked: 'fa-moon-o text-dark-100', unchecked: 'fa-sun-o text-dark-100' }}
                label="Theme"
                labelPosition="left"
              />
            </div>
            <ContextMenuComponent menuOption={menuOption} />
          </div>
        </div>
      </Navbar>
    </>
  );
};

NavbarComponent.displayName = 'NavbarComponent';
export default memo(NavbarComponent);
